<script setup>
import Button from 'dashboard/components-next/button/Button.vue';
import Policy from 'dashboard/components/policy.vue';

const emit = defineEmits(['click']);

const onClick = () => {
  emit('click');
};
</script>

<template>
  <div
    class="flex min-h-96 flex-col items-center justify-center px-6 text-center"
  >
    <span
      class="mb-4 flex size-11 items-center justify-center rounded-lg bg-n-alpha-2 text-n-slate-11"
    >
      <span class="i-lucide-files size-5" />
    </span>
    <h2 class="mb-1 text-base font-semibold text-n-slate-12">
      {{ $t('CAPTAIN.DOCUMENTS.EMPTY_STATE.TITLE') }}
    </h2>
    <p class="mb-4 max-w-md text-sm text-n-slate-10">
      {{ $t('CAPTAIN.DOCUMENTS.EMPTY_STATE.SUBTITLE') }}
    </p>
    <Policy :permissions="['administrator']">
      <Button
        :label="$t('CAPTAIN.DOCUMENTS.ADD_NEW')"
        icon="i-lucide-plus"
        size="sm"
        @click="onClick"
      />
    </Policy>
  </div>
</template>
